module.exports = __webpack_public_path__ + "img/LogoWeConnect_Gris.739d93f7.png";